import { logger } from '@vista/omnichannel-components-domain';
import { OrderPaymentFormEmbeddedPaymentConnectorLoadingState as LoadingState } from '../subcomponents/embedded-payment-connector';
import { OrderPaymentFormEmbeddedPaymentConnectorActionType as ActionType } from './embedded-payment-connector-action-type';
export const OrderPaymentFormEmbeddedPaymentConnectorActionReducer = (state, action) => {
    switch (action.type) {
        case ActionType.LoadingPaymentClient: {
            return Object.assign(Object.assign({}, state), { loadingState: LoadingState.LoadingConnector, paymentClient: undefined });
        }
        case ActionType.LoadedPaymentClient: {
            return Object.assign(Object.assign({}, state), { loadingState: LoadingState.Success, paymentClient: action.paymentClient });
        }
        case ActionType.PaymentStarting: {
            return Object.assign(Object.assign({}, state), { loadingState: LoadingState.ProcessingPayment });
        }
        case ActionType.PaymentButtonStateChanged: {
            return Object.assign(Object.assign({}, state), { paymentButtonState: action.paymentButtonState });
        }
        default: {
            logger.error(`Unknown OrderPaymentFormEmbeddedPaymentConnectorActionType ${action.type}.`);
            return state;
        }
    }
};
